import { useAuthStore } from "#src/store/auth";
import { rememberRoute } from "#src/utils/remember-route";

/**
 * @en Redirects to the login page
 *
 * @returns No return value
 */
export function goLogin() {
	// @en Reset the login state (clear tokens, etc.)
	useAuthStore.getState().reset();
	// @en Redirect to the login page, including the route information to remember (for post-login redirection)
	window.location.href = `${import.meta.env.BASE_URL}login${rememberRoute()}`;
}
